// ==================================================================================
// Digital Approval System (DAS) - Shared status color map for reports
// ==================================================================================
// Used by U1 Submission Trend, U6 Workflow Summary, and anywhere else that
// renders a request-status donut/pie. Lookup is case-insensitive; any status
// not in the map falls back to the neutral gray.
// ==================================================================================

const STATUS_COLOR_MAP: Record<string, string> = {
  approved: '#10b981',       // green — universally success
  submitted: '#2563eb',      // blue — informational
  rejected: '#dc2626',       // red — denied
  'in review': '#f59e0b',    // amber — ongoing processing
  'pre approved': '#14b8a6', // teal — positive but not final
  returned: '#a855f7',       // purple — sent back / rework
};

export const FALLBACK_STATUS_COLOR = '#9ca3af';

export const statusColor = (status: string): string =>
  STATUS_COLOR_MAP[status.trim().toLowerCase()] ?? FALLBACK_STATUS_COLOR;
